import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../ui/alert-dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Button } from "../ui/button";
import { MoreVertical } from "lucide-react";
import { TableAction } from "./data-table";
import { useState } from "react";

interface CurrentActionsProps<T = any> {
  actions: TableAction<T>[];
  row: T;
}

export default function CurrentActions<T>({
  actions,
  row,
}: CurrentActionsProps<T>) {
  const [alertAction, setAlertAction] = useState<TableAction<T> | null>(null);

  if (!actions || actions.length === 0) return null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon">
            <MoreVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="z-[2000]" sideOffset={5}>
          {actions.map((action) => (
            <DropdownMenuItem
              key={action.id}
              variant={action.variant}
              onClick={() => {
                if (action.alert) {
                  setAlertAction(action);
                } else {
                  action.onClick(row);
                }
              }}
              className="cursor-pointer"
            >
              {action.icon && (
                <span className={`mr-2 text-${action.variant}`}>
                  {action.icon}
                </span>
              )}
              {action.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>

      {alertAction && (
        <AlertDialog
          open={!!alertAction}
          onOpenChange={(open) => !open && setAlertAction(null)}
        >
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>{alertAction.alert?.title}</AlertDialogTitle>
              <AlertDialogDescription>
                {alertAction.alert?.description}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancelar</AlertDialogCancel>
              <AlertDialogAction
                onClick={() => {
                  alertAction.onClick(row);
                  setAlertAction(null);
                }}
              >
                Confirmar
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </>
  );
}
